<template>
  <button class="toggle-button" :class="classes" @click="handleToggle">
    <i
      v-for="(icon, index) in icons"
      :key="index"
      :class="`icon icon-${icon}`"
    />
    <span class="slider"></span>
  </button>
</template>

<script>
export default {
  name: "ToggleButton",
  props: {
    icons: {
      type: Array,
      required: true,
      validator(value) {
        return value.length === 2;
      },
    },
    activeDefault: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["toggle"],
  data() {
    return {
      active: this.activeDefault,
    };
  },
  computed: {
    classes() {
      return {
        "toggle-button--active": this.active,
      };
    },
  },
  methods: {
    handleToggle() {
      this.active = !this.active;
      this.$emit("toggle", this.active);
    },
  },
};
</script>

<style lang="scss" scoped>
$toggle-size: 26;
$toggle-animation-time: 0.5s;

.toggle-button {
  outline: none;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  background: $color-grey-light;
  height: $toggle-size + 0px;
  align-items: center;
  border-radius: $toggle-size + 0px;
  position: relative;
  overflow: hidden;
  transition: all 0.5s;

  .icon {
    flex: 1 0 auto;
    width: $toggle-size + 0px;
    display: block;
    z-index: 1;
    transition: color $toggle-animation-time ease;
    font-size: $toggle-size + 0px;

    &:first-of-type {
      color: $color-grey-light;
    }
    &:last-of-type {
      color: $color-black;
    }
  }

  .slider {
    height: $toggle-size + 0px;
    width: $toggle-size + 0px;
    position: absolute;
    left: 0;
    background: $color-black;
    border-radius: 50%;
    transition: transform $toggle-animation-time;
  }

  &--active {
    .icon:first-of-type {
      color: $color-black;
    }
    .icon:last-of-type {
      color: $color-grey-light;
    }

    .slider {
      transform: translateX(100%);
    }
  }
}
</style>
